import BlogsDetailsComponent from "component/Landing/Blogs/BlogsDetails";
import DiscountBanner from "component/Landing/Home/DiscountBanner";

const BlogsDetails = () => {
  return (
    <>
      <BlogsDetailsComponent />
      {/* <DiscountBanner /> */}
    </>
  );
};

export default BlogsDetails;
